// extracted by mini-css-extract-plugin
module.exports = {"container":"TablePlaceholder_container__ze5kj"};